import { Navigate, useLocation, useParams } from 'react-router-dom'
import useStorages from '@/hooks/useStorages'
import { setTargetStorageSilently } from '@/utils/targetStorage'

const LegacyStorageRedirect = () => {
    const { storageId } = useParams<{ storageId: string }>()
    const location = useLocation()
    const { storages } = useStorages()

    if (!storageId) {
        return <Navigate to="/storages" replace />
    }

    const name = storages?.find((storage) => storage.id === storageId)?.name || ''
    setTargetStorageSilently(storageId, name)

    const prefix = `/storages/${storageId}`
    const suffix = location.pathname.startsWith(prefix) ? location.pathname.slice(prefix.length) : ''

    return <Navigate to={`/storage${suffix}${location.search}${location.hash}`} replace />
}

export default LegacyStorageRedirect
